module.exports = __webpack_public_path__ + "static/me-baad1f1af588f3fe88080fb0e504aed3.jpg";